'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSuperProperties;

var _dom_helper = require('./dom_helper');

function getSuperProperties() {
  var queryParams = (0, _dom_helper.parseQueryParams)(window.location.search),
      identityId = getIdentityId(queryParams.identityID),
      date = Date.now();
  var superProps = {
    abTestCluster: (0, _dom_helper.readCookie)('split'),
    abTestClusterThreshold: (0, _dom_helper.readCookie)('split_tcv'),
    application: 'rdc',
    aid: queryParams.aid || null,
    brandExperience: 'rdc-responsive',
    contentId: queryParams.content_id || null,
    currentDate: (0, _dom_helper.getCurrentDateWithWeek)(new Date(date)),
    edwSessionId: (0, _dom_helper.readCookie)('__ssn'),
    edwVisitorId: (0, _dom_helper.readCookie)('__vst'),
    loginStatus: identityId ? 'y' : 'n',
    mid: queryParams.mid || null,
    rdcTrackingEnabled: 'y',
    publisher: getPublisher(queryParams.cid, queryParams.pid),
    registeredUserActivity: identityId ? 'registered-user' : 'not-registered',
    rid: queryParams.rid || null,
    identityId: identityId,
    sessionStartTime: (0, _dom_helper.readCookie)('__ssnstarttime'),
    threshold: (0, _dom_helper.readCookie)('threshold_value'),
    utcTimestamp: date
  };
  if (typeof window.rdcxreferrer !== 'undefined') {
    superProps.referrer = window.rdcxreferrer;
  };
  return superProps;
} // superProperties are the data that need to be sent on every single track event in all rdc web apps
;

var getPublisher = function getPublisher(cid, pid) {
  cid = cid || null;
  pid = pid || null;
  return cid && cid.toLowerCase().includes('cj_') ? 'cj:' + pid : pid;
};

var getIdentityId = function getIdentityId(identityId) {
  return (0, _dom_helper.parseQueryParams)((0, _dom_helper.readCookie)("REMEMBER_ME") || '').regID || identityId || null;
};


//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/@moveinc/rdc-tracking/distribution/super_properties.js
// module id = 912
// module chunks = 48 49 51